import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'
import { useAuth } from '@lib/auth/useAuth'

interface RouterContext {
  auth: ReturnType<typeof useAuth>
}

// Only pulled in when running the Vite dev server (`npm run dev`). Every built bundle
// — lc, dv and pd — evaluates this to the no-op component, so the devtools chunk is
// tree-shaken out of the deployment rather than merely hidden.
const TanStackRouterDevtools = import.meta.env.DEV
  ? lazy(() =>
      import('@tanstack/router-devtools').then((module) => ({
        default: module.TanStackRouterDevtools
      }))
    )
  : () => null

const Root = () => {
  return (
    <>
      <Outlet />
      <Suspense fallback={null}>
        <TanStackRouterDevtools />
      </Suspense>
    </>
  )
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => {
    return <Root />
  }
})
